/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationForAlertsAws extends models.GovernanceConfigurationBaseForAlerts {
    constructor() {
        super();
        this.setDiscriminator("GovernanceConfigurationForAlertsAws");
    }

    getFixupPrototypeFunction() { return GovernanceConfigurationForAlertsAws.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationForAlertsAws>): GovernanceConfigurationForAlertsAws {
        let obj = Object.assign(new GovernanceConfigurationForAlertsAws(), model);
        GovernanceConfigurationForAlertsAws.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationForAlertsAws>): GovernanceConfigurationForAlertsAws {
        if (!model) return null;
        return GovernanceConfigurationForAlertsAws.newInstance(<GovernanceConfigurationForAlertsAws> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationForAlertsAws) {
        if (!obj) return;

        models.GovernanceConfigurationForAlertsAws.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationForAlertsAws): boolean {
        if (models.GovernanceConfigurationBaseForAlerts.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationForAlertsAws.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Specifies whether metric alert configuration enabled or not
     */
    enabled: boolean;

}
